import { SourceSettings } from '../source-settings';

export interface QuestionnaireSourceSettings extends SourceSettings {
  type: 'fill-questionnaire';
}
